import { apiConfig } from "@pjs/asset-core";

apiConfig.reportInappropriate = (assetId) => `${window.config.getApiBaseUrl()}Asset/ReportInappropriate/${assetId}`;
apiConfig.publicReportInappropriate = (assetId) => `${window.config.getApiBaseUrl()}Asset/Public/ReportInappropriate/${assetId}`;
